import React from 'react';
import { Box } from '@hover/blueprint';
import { StaticImage } from 'gatsby-plugin-image';
import {
  iCamera,
  iHome,
  iImage,
  iList,
  iMessageSquare,
  iPenTool,
  iRotateCcw,
  iShare2,
  iZap,
} from '@hover/icons';
import type { IHomeownerRenderingStep } from '../interfaces/IHomeownerRenderingStep';
import type { IHomeownerDesignIncluded } from '../interfaces/IHomeownerDesignIncluded';
import { SlideBadge } from './homeownerRendering';

export const HOMEOWNER_DESIGN_STEPS: IHomeownerRenderingStep[] = [
  {
    key: 0,
    icon: iCamera,
    title: 'Take a photo',
    description: 'Share an image (or blueprint) of your home with us.',
  },
  {
    key: 1,
    icon: iMessageSquare,
    title: 'Share your style',
    description:
      'Take our style quiz and share project details including what you want changed.',
  },
  {
    key: 2,
    icon: iImage,
    title: 'Get your designs',
    description:
      'Sit back and relax. We craft personalized designs of your home.',
  },
];

export const WHATS_INCLUDED: IHomeownerDesignIncluded[] = [
  {
    key: 0,
    icon: iPenTool,
    title: '3 Unique Designs',
    body: 'Three renderings to compare options',
  },
  {
    key: 1,
    icon: iHome,
    title: 'New Homes and Renovations',
    body: 'Envision either one',
  },
  {
    key: 2,
    icon: iRotateCcw,
    title: 'Unlimited Revisions',
    body: 'Make changes for an entire month',
  },
  {
    key: 3,
    icon: iList,
    title: 'Colors & Products',
    body: 'Product info included with designs',
  },
  {
    key: 4,
    icon: iZap,
    title: 'Quick Turn-Around',
    body: 'Typically less than a week',
  },
  {
    key: 5,
    icon: iShare2,
    title: 'Sharing',
    body: 'Get feedback from friends or a Pro',
  },
];

export const HOMEOWNER_DESIGN_RETHINK_SLIDES = [
  {
    image: (
      <Box position="relative">
        <StaticImage
          src="../assets/images/homeowner_rethink_2.jpg"
          alt=""
          objectFit="cover"
        />
        <SlideBadge>After 1</SlideBadge>
      </Box>
    ),
    thumbnail: (
      <StaticImage
        src="../assets/images/homeowner_rethink_thumb_2.jpg"
        alt=""
      />
    ),
    key: 0,
  },
  {
    image: (
      <Box position="relative">
        <StaticImage
          src="../assets/images/homeowner_rethink_3.jpg"
          alt=""
          objectFit="cover"
        />
        <SlideBadge>After 2</SlideBadge>
      </Box>
    ),
    thumbnail: (
      <StaticImage
        src="../assets/images/homeowner_rethink_thumb_3.jpg"
        alt=""
      />
    ),
    key: 1,
  },
  {
    image: (
      <Box position="relative">
        <StaticImage
          src="../assets/images/homeowner_rethink_4.jpg"
          alt=""
          objectFit="cover"
        />
        <SlideBadge>After 3</SlideBadge>
      </Box>
    ),
    thumbnail: (
      <StaticImage
        src="../assets/images/homeowner_rethink_thumb_4.jpg"
        alt=""
      />
    ),
    key: 2,
  },
];
